import CIMSFormItem from '../..'
import UserRoleSelect from '../../../CIMSSelect/common/UserRoleSelect'
import { CIMSFormItemProps } from '../../types'

/**
 * wraps a {@link CIMSFormItem} where the roles and users should be next to each
 * other in a row
 *
 * you must wrap anything using this form item in the UserRoleSelectProvider
 *
 * the name of the form item is `rolesUsers`
 */
const UserAndRolesFormItem: React.FC<
  Pick<CIMSFormItemProps, 'label'> & {
    /**
     * sets the help text for the form item
     *
     * @example
     * `Roles, or additional Users, will be able to ${action}`
     */
    action: string
  }
> = ({ label, action }) => {
  return (
    <CIMSFormItem
      full
      name="rolesUsers"
      label={label}
      help={`Roles, or additional Users, will be able to ${action}`}
    >
      <UserRoleSelect multiple />
    </CIMSFormItem>
  )
}

export default UserAndRolesFormItem
